import React, { memo } from 'react';
import classnames from 'classnames';

import { TextField } from '../material-ui/TextField';
import { useCustomField } from './useCustomField';
import { useStyles } from './useStyles';

export const CustomField = memo((props) => {
    const {
        name,
        validator,
        onEditField,
        onChangeValue,
        label,
        defaultValue,
        value,
        className,
        helperText,
        required,
        type = 'text',
        autoComplete = 'off',
        ...restProps
    } = props;
    const classes = useStyles();

    const { currentValue, customHelperText, errorText, handleChange, handleEdit, handleInputFocus } = useCustomField(
        validator,
        onEditField,
        onChangeValue,
        defaultValue,
        value,
        helperText,
        required
    );

    const InputLabelProps = React.useMemo(
        () => ({
            shrink: true,
            className: classes.label,
            ...props.InputLabelProps,
        }),
        []
    );

    return (
        <TextField
            {...restProps}
            {...{ name, label, className, InputLabelProps, type, autoComplete }}
            value={currentValue}
            FormHelperTextProps={{
                className: classes.helperText,
            }}
            placeholder={label}
            onBlur={handleEdit}
            onChange={handleChange}
            onFocus={handleInputFocus}
            helperText={customHelperText}
            error={Boolean(errorText)}
            fullWidth={true}
            className={classnames(classes.field, className)}
            key={name}
            margin="normal"
        />
    );
});

CustomField.displayName = 'CustomField';
